import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
//import TinymceEditor from 'components/base/TinymceEditor';
import PitchDeckLayout from 'layouts/PitchDeckLayout';
import { Card, Col } from 'react-bootstrap';

const CreateNewPitchDeck = () => {
  return (
    <PitchDeckLayout page="compose">
      <Col>
        <Card className="email-content d-flex flex-column h-100">
          <Card.Body className="d-flex flex-column h-100">
            <form className="flex-grow-1 d-flex flex-column">
              <div className="mb-3 flex-grow-1">
                <div
                  id="carouselExampleDark"
                  className="carousel carousel-dark slide h-100"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#carouselExampleDark"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleDark"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleDark"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                  </div>
                  <div className="carousel-inner h-100">
                    <div className="carousel-item active h-100">
                      <img
                        src="https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/echoes of limbo.png"
                        className="w-100 h-100"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item" data-bs-interval="2000">
                      <img
                        src="https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/echoes of limbo3.png"
                        className="d-block w-100"
                        alt="..."
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>Tagline</h5>
                        <p>Go see this movie if you like popcorn</p>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <img
                        src="https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/echoes of limbo4.png"
                        className="d-block w-100"
                        alt="..."
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>Synopsis</h5>
                        <p>
                          I said do you speak my language. He just smiled...{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3"></div>
                <div className="d-flex">
                  <Button
                    variant="link"
                    className="text-900 fs-10 text-decoration-none"
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-10"
                    type="submit"
                    endIcon={<FontAwesomeIcon icon={faPaperPlane} />}
                  >
                    Publish
                  </Button>
                </div>
              </div>
            </form>
          </Card.Body>
        </Card>
      </Col>
    </PitchDeckLayout>
  );
};

export default CreateNewPitchDeck;
